import { saveAs } from 'save-as';
import { useMutation } from '@tanstack/react-query';

import { useToast } from 'Store/toast';
import { useLoader } from 'Store/loader';
import getScheduleTemplate from 'Api/schedule/getScheduleTemplate';
import { downloadTemplateText } from 'Const/schedule';

const useGetScheduleTemplate = () => {
  const { onOpenToast } = useToast();
  const { onShowLoader, onResetLoader } = useLoader();

  return useMutation({
    mutationKey: ['schedule-uplaod-template'],
    mutationFn: async () => {
      let response = await getScheduleTemplate();

      return response;
    },
    onMutate: () => {
      onShowLoader({ variant: 'loader-primary' });
    },
    onSuccess: (data) => {
      const blob = new Blob([data]);
      saveAs(blob, `Schedule Data.xlsx`);
      onOpenToast({
        status: 'success',
        description: downloadTemplateText?.successDownloadTemplateText,
        duration: 3,
        alwaysShow: false,
      });
    },
    onError: () => {
      onOpenToast({
        status: 'error',
        description: downloadTemplateText?.failedDownloadTemplateText,
        duration: 3,
        alwaysShow: false,
      });
    },
    onSettled: () => {
      onResetLoader();
    },
  });
};

export default useGetScheduleTemplate;
